import { FunctionComponent } from 'react';

export enum NavbarItem {
  HOME = 'Home',
  PROFILE = 'Profile',
  CHECKLIST = 'Checklist',
  CHAT = 'Chat',
  RESOURCES = 'Resources',
  PROGRESS = 'Progress',
}
export interface TabItem {
  icon: FunctionComponent;
  label: string;
  route: string;
  tabValue: NavbarItem;
  showBadge?: boolean;
}
export type NavigationTab = {
  route: string;
  label: String;
  selectedTabValue: NavbarItem;
};

export interface NavbarProps {
  onBrandLogoClick: () => void;
  brandLogo: React.ReactNode;
  onTabChange: (tabObject: TabItem) => void;
  selectedTab?: NavbarItem;
  navItemList: TabItem[];
}
